import { render, staticRenderFns } from "./CambiarPassword.vue?vue&type=template&id=5f46a38a&"
import script from "./CambiarPassword.vue?vue&type=script&lang=js&"
export * from "./CambiarPassword.vue?vue&type=script&lang=js&"
import style0 from "./CambiarPassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports